class InfiartSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.prev = this.querySelector('[data-slider-prev]');
    this.next = this.querySelector('[data-slider-next]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.scroll(-1));
    this.next?.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    window.addEventListener('resize', () => this.updateButtons(), { passive: true });
    this.updateButtons();
  }

  scroll(direction) {
    const first = this.track.querySelector('[data-slider-item]');
    if (!first) return;
    const styles = getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);
    const amount = first.getBoundingClientRect().width + gap;
    this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  updateButtons() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }
}

if (!customElements.get('infiart-slider')) {
  customElements.define('infiart-slider', InfiartSlider);
}
